// @flow

// Utils
import createReducer from 'fc-utils/createReducer'

// Initial State
import initialState from './initialState'
import datatable from './datatable'

// Assets Operator
import {
  reducers as operatorReducers,
} from 'hfty-operator-recommendations'

// Exports
export default createReducer({
  ...initialState,
}, {
  ...datatable.reducers,
  ...operatorReducers,
})
